import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import logo from '../../images/btwb_logo.svg';
import SearchBar from '../SearchBar';

import './Header.css';

class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchStatus: false
    }

    this.toggleSearch = this.toggleSearch.bind(this);
    this.hideSearch = this.hideSearch.bind(this);
  }

  toggleSearch() {
    let searchStatus = this.state.searchStatus;
    this.setState({
      searchStatus: !searchStatus
    }, () => {
    });
  }
  hideSearch() {
    this.setState({
      searchStatus: false
    })
  }

  render() {
    return(
      <header>
        <div className="search relative w-100 tr bg-white">
          <Grid 
            container
            justify="space-between" 
            alignItems="center">
            <Grid 
              item
              md={3}
              sm={4}
              xs={6}
              className="tl">
              {!this.props.hideHeader &&
                <a href="https://btwb.com"><img className="h15 h2-ns logo mt1" alt="sbtbb-logo" src={logo} /></a>
              }
            </Grid>
            <Grid 
              item
              md={9}
              sm={8}
              xs={6}
              className="l pa3">
              <Grid 
                alignItems="center"
                container
                spacing={8}
                justify="flex-end">
                 {/*<Grid item>
                 <span 
                    className="pa2 pointer f4"
                    onClick={this.toggleSearch}>
                    <i className="fas fa-search"></i>
                  </span>
                </Grid>*/}

                <Grid 
                  item 
                  xs={8} 
                  className="tr f7 mr2">
                  <Button 
                    variant="contained"
                    color="secondary"
                    className={'pointer button-fix'} 
                    onClick={this.props.toggleWorkoutDescription}>
                    <span className="f7">{this.props.hideWorkoutDescription ? 'Show' : 'Hide'} events</span>
                  </Button>
                </Grid>
                {/*<Grid item>

                  {!this.props.hideHeader &&
                    <a href={process.env.REACT_APP_DIVISION_ROOT === 3 ? 'https://rogue.btwb.com/leaderboard-unverified' : 'https://rogue.btwb.com/leaderboard/index.html'}>
                      <Button
                        variant="contained"
                        className="register-button"
                        color="secondary">
                        {process.env.REACT_APP_DIVISION_ROOT === 3 ? 'Verified' : 'Unverified'}
                      </Button>
                    </a>
                  }
                </Grid>*/}
              </Grid>
            </Grid>
          </Grid>
          {/*<SearchBar 
            currentName={this.props.name}
            updateName={this.props.updateName}
            updatePage={this.props.updatePage}
            onSelect={this.props.updatePage}
            leaderboardId={this.props.leaderboardId}
            backupLeaderboardId={this.props.backupLeaderboardId}
            toggleSearch={this.toggleSearch}
            showing={this.state.searchStatus}
            hideSearch={this.hideSearch}
          />*/}
        </div>
        {!this.props.hideHeader &&
          <div className="bg-light-gray mb4">
            <div className="relative w-100 pa3 bg-second-header">
              <Grid 
                container
                alignItems="center"
                justify="space-between">
                <Grid 
                  item 
                  xs={12} 
                  className="tl f7 pr-3">
                  Join by adding <span className="yellow">#CrossFitGames</span> to your btwb result. <a href="btwb.com" href="_blank" rel="noopener">More Details.</a>
                </Grid>
              </Grid>
            </div>
          </div>
        }
      </header>
    )
  }
}

Header.propTypes = {
  boolean: PropTypes.bool,
  // updatePage: PropTypes.func.isRequired,
  // suggestions: PropTypes.array.isRequired,
  currentValue: PropTypes.string,
  leaderboardId: PropTypes.number.isRequired,
  backupLeaderboardId: PropTypes.number.isRequired,
  toggleWorkoutDescription: PropTypes.func.isRequired,
  hideWorkoutDescription: PropTypes.bool.isRequired
}

export default Header;